export default [
  {
    name: 'asset-transfer',
    path: '/asset/transfer',
    component: () => import('@/views/asset-transfer/AssetTransferWizard')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeAssetTransfer.js